/**
 *
 * @return {Promise<boolean>}
 */
async function isSubscribed() {
    return false;
}

const CloudSaveManager = {
    subscribed: false,
    subscriptionId: "",

    /**
     * Check if user is subscribed to cloud save feature
     *
     * @return {Promise<boolean>}
     */
    async isSubscribed() {
        try {
            return await isSubscribed();
        } catch(error) {
            captureException(error);

            return false;
        }
    },

    handleOffline() {
        // const online = window.navigator.onLine;
    },

    /**
     * Generate unique id for the calculation
     *
     * @return {string}
     */
    getUid() {
        return String();
    },

    setUid() {},

    /**
     *
     * @return {Promise<object>|Promise<void>}
     */
    async fetchSettings() {
        if (!await this.isSubscribed()) return;

        try {
            const response = await this.callCloudApi("get", "settings");

            return response.body;
        } catch(error) {
            captureException(error);
        }
    },

    /**
     *
     * @return {Promise<void>}
     */
    async saveSettings() {
        if (!await this.isSubscribed()) return;
        const data = encodeURIComponent(JSON.stringify(app.$store.state.localSettings));
        await this.storeCloud("post", "settings", {data});
    },

    /**
     * @return {void}
     */
    async loadCalcs() {
        await this.storeCloud("get", "calculations", {});
    },

    /**
     *
     * @param {object} data
     * @param {boolean} id
     * @return {void}
     */
    async saveCalc(data, id) {
        if (!await this.isSubscribed()) return;
        await this.storeCloud("post", "calculations", {
            calcId: id,
            data: encodeURIComponent(JSON.stringify(data)),
        });
    },

    /**
     *
     * @param {string} id
     * @return {Promise<void>}
     */
    async deleteCalc(id) {
        if (!await this.isSubscribed()) return;
        await this.storeCloud("delete", "calculations", {
            calcId: id,
        });
    },

    /**
     * Send data to flutter service
     *
     * @param {"get"|"post"|"delete"} method (get | post | delete)
     * @param {"calculations"|"settings"} resource (calculations | settings)
     * @param {string | object} payload
     * @return {Promise<void>}
     */
    storeCloud(method, resource, payload) {
        return this.callCloudApi(method, resource, payload);
    },

    /**
     *
     * @param {"get"|"post"|"delete"} method
     * @param {"calculations"|"settings"} resource
     * @param {object} payload
     * @return {Promise<void>}
     */
    async callCloudApi(method, resource, payload) {
        const userId = localStorage.getItem("originalSubscriptionId");

        if (!userId) {
            // eslint-disable-next-line no-console
            return console.log("User id is not provided!");
        }

        const invokeUrl = "https://wxgfupgt19.execute-api.us-east-1.amazonaws.com/Beta/";
        const url = `${invokeUrl}${resource}/${userId}`;

        try {
            const response = await request[method](url)
                .send(payload)
                .withCredentials(false)
                .set("accept", "application/json");
        } catch(error) {
            captureException(error);
        }
    },

};

export default CloudSaveManager;
